// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2b_TE","fullView":"styles_fullView__3Y7uz"};